// Button Component
// H-F015: Migrado al patrón React 19 — ref como prop directa, sin forwardRef
import type { ButtonHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  ref?: React.Ref<HTMLButtonElement>;
}

function Button({ className, variant = 'default', size = 'default', ref, ...props }: ButtonProps) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center rounded-md text-sm font-medium',
        'transition-all duration-150 ease-in-out',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-900',
        'disabled:pointer-events-none disabled:opacity-50',
        'active:scale-[0.98]',
        {
          'bg-emerald-600 text-white hover:bg-emerald-700 focus-visible:ring-emerald-500': variant === 'default',
          'bg-red-600 text-white hover:bg-red-700 focus-visible:ring-red-500': variant === 'destructive',
          'border border-gray-300 bg-white hover:bg-gray-50 focus-visible:ring-emerald-500 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700': variant === 'outline',
          'bg-gray-100 text-gray-900 hover:bg-gray-200 focus-visible:ring-emerald-500 dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700': variant === 'secondary',
          'hover:bg-gray-100 hover:text-gray-900 focus-visible:ring-emerald-500 dark:hover:bg-gray-800 dark:hover:text-gray-100': variant === 'ghost',
          'text-emerald-600 underline-offset-4 hover:underline focus-visible:ring-emerald-500 dark:text-emerald-400': variant === 'link',
          'h-10 px-4 py-2': size === 'default',
          'h-9 rounded-md px-3 py-1.5': size === 'sm',
          'h-11 rounded-md px-8 py-2.5': size === 'lg',
          'h-10 w-10': size === 'icon',
        },
        className
      )}
      ref={ref}
      {...props}
    />
  );
}

export { Button };
